//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import $ from 'jquery';
import Highcharts from 'highcharts';

(function() {
    'use strict';
    
    /**
     * Custom jQuery function to scroll to specific comment
     * in comments thread (used when replying). Stolen from
     * http://stackoverflow.com/questions/2346011/jquery-scroll-to-an-element-within-an-overflowed-div
     */
    $.fn.scrollTo = function (elem, speed, complete) {
        var $this = $(this);
        if (!angular.isDefined(elem)) return null;
        $this.animate({
            scrollTop: $this.scrollTop() - $this.offset().top + elem.offset().top
        }, speed == null ? 1000 : speed, 'swing', complete);
        return this;
    };

    // Highcharts jquery mixin. This was originally defined in the highcharts source, but
    // was bound to a global instance of jquery, which we no longer rely on.
    $.fn.highcharts = function () {
        var args = [].slice.call(arguments);
        if (this[0]) { // this[0] is the renderTo div
            // Create the chart
            if (args[0]) {
                new Highcharts[ // eslint-disable-line no-new
                    // Constructor defaults to Chart
                    Highcharts.isString(args[0]) ? args.shift() : 'Chart'
                ](this[0], args[0], args[1]);
                return this;
            }
            // When called without parameters or with the return argument,
            // return an existing chart
            return Highcharts.charts[Highcharts.attr(this[0], 'data-highcharts-chart')];
        }
    };

})();
